import React from 'react';
import { useHistory } from 'react-router';
import { ImCross, ImMenu } from 'react-icons/im';


const MobileMenu = ({ isOpen, setIsOpen }) => {
    // react-router hook
    const history = useHistory();

    const handleClick = () => {
        history.push('/')
    };

    return (
        <nav className='flex lg:hidden bg-green-400 py-2 px-4 justify-between text-lg items-center font-bold fixed w-full z-50'>
            <h1 className='text-2xl' onClick={handleClick}>Sindabad</h1>
            {
                isOpen ?
                    <ImCross className='text-2xl' onClick={() => setIsOpen(!isOpen)} /> :
                    <ImMenu className='text-2xl' onClick={() => setIsOpen(!isOpen)} />
            }
        </nav>
    )
}

export default MobileMenu;
